import React, {useState} from "react";
import {Editor} from "react-draft-wysiwyg";
import {Box, FormControlLabel, Grid, Switch, TextField, useMediaQuery, useTheme} from "@mui/material";
import draftToHtml from "draftjs-to-html";
import {ContentState, convertToRaw, EditorState} from "draft-js";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { GREEN_700 } from "../core/pvtaStyles";


interface IProps {
    txt: string;
    setTxt: Function;
    placeholder?: string;
}


export const CustomEditor: React.FC<IProps> = (props) => {
    const [editorState, setEditorState] = useState<any>(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(props.txt).contentBlocks)));
    const [htmlEditorOpen, setHtmlEditorOpen] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // true auf kleinen Bildschirmen


    const onEditorStateChange = (editorState: any) => {
        setEditorState(editorState);
        props.setTxt(draftToHtml((convertToRaw((editorState.getCurrentContent())))))

    };


    const handleChangeNew = () => {
        if (!htmlEditorOpen) {
            props.setTxt(draftToHtml((convertToRaw((editorState.getCurrentContent())))))
        } else {
            setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(props.txt).contentBlocks)))
        }
        setHtmlEditorOpen(!htmlEditorOpen);
    }


    if (isMobile) {
        return (
            <Grid item xs={12}>
                <TextField
                    label="Nachricht"
                    placeholder={props.placeholder}
                    multiline
                    fullWidth
                    rows={8}
                    value={props.txt}
                    onChange={(e) => props.setTxt(e.target.value)}
                    sx={{ minWidth: 0 }}
                />
            </Grid>
        );
    }


    // @ts-ignore
    return (
        <>
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <FormControlLabel
                        control={<Switch
                            checked={htmlEditorOpen}
                            onChange={handleChangeNew}
                            inputProps={{'aria-label': 'controlled'}}
                            size="small"
                        />}
                        label="HTML Ansicht"
                        labelPlacement="start"
                        sx={{ mr: 0 }}
                    />
                </Box>
            </Grid>

            {!htmlEditorOpen &&
                <Grid item xs={12}>
                    <Box
                        sx={{
                            minWidth: 0,
                            maxWidth: '100%',
                            minHeight: 140,
                            borderRadius: 2,
                            border: '1px solid',
                            borderColor: 'divider',
                            backgroundColor: 'background.paper',
                            p: 1,
                            transition: 'border-color 200ms ease, box-shadow 200ms ease',
                            '&:hover': {
                                borderColor: '#cfc7bb',
                            },
                            '&:focus-within': {
                                borderColor: GREEN_700,
                                boxShadow: '0 0 0 3px rgba(18, 61, 36, 0.12)',
                            },
                            '& .rdw-editor-toolbar': {
                                border: 'none',
                                borderBottom: '1px solid',
                                borderColor: 'divider',
                                backgroundColor: '#f9f7f3',
                                borderTopLeftRadius: 8,
                                borderTopRightRadius: 8,
                                padding: '6px',
                                flexWrap: 'wrap',
                                maxWidth: '100%',
                            },
                            '& .rdw-editor-main': {
                                padding: '10px 12px',
                                minHeight: 160,
                            },
                            '& .rdw-option-wrapper': {
                                borderRadius: 8,
                                transition: 'background-color 200ms ease, box-shadow 200ms ease',
                            },
                            '& .rdw-option-wrapper:hover': {
                                backgroundColor: '#ece7df',
                                boxShadow: '0px 4px 10px rgba(15, 23, 42, 0.12)',
                            },
                        }}
                    >
                        <Editor
                            editorState={editorState}
                            placeholder={props.placeholder}
                            toolbarClassName="toolbarClassName"
                            wrapperClassName="wrapperClassName"
                            editorClassName="editorClassName"
                            onEditorStateChange={onEditorStateChange}
                        />
                    </Box>
                </Grid>
            }

            {htmlEditorOpen &&
                <Grid item xs={12}>
                    <TextField
                        id="outlined-multiline-static"
                        label="HTML Editor"
                        multiline
                        fullWidth={true}
                        rows={10}
                        value={props.txt}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => props.setTxt(event.target.value)}
                        //defaultValue={(props.txt !== undefined) && props.txt}
                        size="small"
                    />
                </Grid>
            }
        </>
    )
}
